module.exports = __webpack_public_path__ + "static/media/840644.32b65288.svg";